<template src="./html/Show.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Calendar from '../../calendar/views/Index.vue'
	import MediaManager from './../../../MediaManager/layout/MediaManager.vue'
	import TasksMap from './TasksMap'
	import Timer from '../../timers/views/Index.vue'
	import Comments from './../../../cms/comments/layout/Comments.vue'
	import IncidentReports from './../components/incidentReports/layout/IncidentReports.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'calendar': Calendar,
			'media-manager': MediaManager,
			'tasks-map': TasksMap,
			'timer': Timer,
			'comments': Comments,
			'incident-reports': IncidentReports,
		},
		data () {
			return {
				item: null,
				media: null,

				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: null,
				},
			}
		},
		watch: {
			'$route.params.id': function(value) {
				this.getItem()
			},
		},
		created () {
			this.getItem()
			this.getMedia()
		},
		methods: {
			getItem () {
				this.$http.get('admin/projects/tasks/' + this.$route.params.id)
				.then(response => {
					this.item = response.body
					this.dropzone.url = this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/projects/tasks/' + this.item.id;
				}).catch(function(response) {
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning"
					});
				})
			},
			getMedia() {
				this.$http.get('admin/projects/tasks/' + this.$route.params.id + '/media/media')
				.then(response => {
					this.media = response.body
				})
			},
			clearData () {
				this.item = null
			},
			reload() {
				this.getMedia()
				this.getItem()
				this.$refs.calendar.getData()
			},
			openTimer (schedule) {
				var ref = 'timer-schedule-' + schedule.id
				this.$refs[ref][0].open()
			},
			canComplete () {
				if(this.item.schedules) {
					if(this.item.schedules.length) {
						for (var i = this.item.schedules.length - 1; i >= 0; i--) {
							if(this.item.schedules[i].done == 0) {
								return false
								break
							}
						}
					}
				}

				if(this.item.schedules) {
					if(!this.item.schedules.length) {
						if(this.item.users) {
							if(this.item.users.length) {
								for (var i = this.item.users.length - 1; i >= 0; i--) {
									var user = this.item.users[i]
									if(user.timers) {
										if(user.timers.length) {
											for (var k = user.timers.length - 1; k >= 0; k--) {
												var timer = user.timers[k]
												if(!timer.done) {
													return false
													break
												}
											}
										}
									}
								}
							}
						}
					}
				}

				return true
			},
			canEdit () {
				var that = this
				if(!this.user.hasRole('admin')) {
					if(this.user.hasRole('manager')) {
						if(this.item.projects) {
							if(this.item.projects.length) {
								var found = this.item.projects.find(function(project) {
									return project.user_id == that.user.id;
								});

								if(found) {
									return true
								}
							}
						}
					}
				} else {
					return true
				}

				return false
			},
			complete() {
				var button = this.$refs.btnComplete
				var l = Ladda.create(button)
				l.start()
				this.$http.get('admin/projects/tasks/'+this.item.id+'/complete')
					.then(response => {
						l.stop()
						this.item.completed = response.body.completed
						this.item.task_status_id = response.body.task_status_id
						this.item.task_status_id = response.body.task_status_id
						this.item.status = response.body.status
						this.reload()
					}).catch(function(response) {
						l.stop()
						swal({
							title: response.statusText,
							text: response.body,
							type: "warning"
						});
					})
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/Show.vue